module.exports = "/images/nl.svg";